// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientDetailsSidebar-module__font-s-10___J9TMm {
  font-size: 10px !important;
}

.PatientDetailsSidebar-module__font-s-12___aqBMY {
  font-size: 12px !important;
}

.PatientDetailsSidebar-module__font-s-13___gvY_U {
  font-size: 13px !important;
}

.PatientDetailsSidebar-module__font-s-14___FQEZL {
  font-size: 14px !important;
}

.PatientDetailsSidebar-module__font-s-15___DzaCR {
  font-size: 15px !important;
}

.PatientDetailsSidebar-module__font-s-16___J_K69 {
  font-size: 16px !important;
}

.PatientDetailsSidebar-module__font-s-18____wfIi {
  font-size: 18px !important;
}

.PatientDetailsSidebar-module__font-s-20___dUIdh {
  font-size: 20px !important;
}

.PatientDetailsSidebar-module__font-s-22___OB_tT {
  font-size: 22px !important;
}

.PatientDetailsSidebar-module__font-s-28___dETqg {
  font-size: 28px !important;
}

.PatientDetailsSidebar-module__font-w-400___qBq7u {
  font-weight: 400 !important;
}

.PatientDetailsSidebar-module__font-w-500___kEkMh {
  font-weight: 500 !important;
}

.PatientDetailsSidebar-module__font-w-600___v6Nkw {
  font-weight: 600 !important;
}

.PatientDetailsSidebar-module__font-w-700___lzPcv {
  font-weight: 700 !important;
}

.PatientDetailsSidebar-module__p-5___I8aY7 {
  padding: 5px !important;
}

.PatientDetailsSidebar-module__p-12___nbQuH {
  padding: 12px !important;
}

.PatientDetailsSidebar-module__p-16___UpZwv {
  padding: 16px !important;
}

.PatientDetailsSidebar-module__p-30___tqdmA {
  padding: 30px !important;
}

.PatientDetailsSidebar-module__p-b-0___PoUnm {
  padding-bottom: 0 !important;
}

.PatientDetailsSidebar-module__p-b-5___VVB9h {
  padding-bottom: 5px !important;
}

.PatientDetailsSidebar-module__p-b-10___OLk9n {
  padding-bottom: 10px !important;
}

.PatientDetailsSidebar-module__p-b-12___IQiU7 {
  padding-bottom: 12px !important;
}

.PatientDetailsSidebar-module__p-b-16___MJ3jA {
  padding-bottom: 16px !important;
}

.PatientDetailsSidebar-module__p-b-18___EzEDF {
  padding-bottom: 18px !important;
}

.PatientDetailsSidebar-module__p-b-20___XSjhg {
  padding-bottom: 20px !important;
}

.PatientDetailsSidebar-module__p-b-25___vyBWJ {
  padding-bottom: 25px !important;
}

.PatientDetailsSidebar-module__p-b-30___GiQ4W {
  padding-bottom: 30px !important;
}

.PatientDetailsSidebar-module__p-b-50___d3PnA {
  padding-bottom: 50px !important;
}

.PatientDetailsSidebar-module__p-t-0___YtkS5 {
  padding-top: 0 !important;
}

.PatientDetailsSidebar-module__p-t-12___BVdcO {
  padding-top: 12px !important;
}

.PatientDetailsSidebar-module__p-t-16___bc7Qg {
  padding-top: 16px !important;
}

.PatientDetailsSidebar-module__p-t-18___ZzDqN {
  padding-top: 18px !important;
}

.PatientDetailsSidebar-module__p-t-20___AOzOI {
  padding-top: 20px !important;
}

.PatientDetailsSidebar-module__p-t-30___ngpue {
  padding-top: 30px !important;
}

.PatientDetailsSidebar-module__p-t-40___TYULE {
  padding-top: 40px !important;
}

.PatientDetailsSidebar-module__p-t-50___vkwQv {
  padding-top: 50px !important;
}

.PatientDetailsSidebar-module__p-l-20___pINhv {
  padding-left: 20px !important;
}

.PatientDetailsSidebar-module__p-l-30___B85Y5 {
  padding-left: 30px !important;
}

.PatientDetailsSidebar-module__p-l-40___HeuX4 {
  padding-left: 40px !important;
}

.PatientDetailsSidebar-module__p-r-16___CITaT {
  padding-right: 16px !important;
}

.PatientDetailsSidebar-module__p-r-20___rkdrs {
  padding-right: 20px !important;
}

.PatientDetailsSidebar-module__p-r-30___BQzSH {
  padding-right: 30px !important;
}

.PatientDetailsSidebar-module__p-r-50___ulefd {
  padding-right: 50px !important;
}

.PatientDetailsSidebar-module__p-r-60___Hom73 {
  padding-right: 60px !important;
}

.PatientDetailsSidebar-module__m-b-1___L7dNq {
  margin-bottom: 1px !important;
}

.PatientDetailsSidebar-module__m-b-2___ramJT {
  margin-bottom: 2px !important;
}

.PatientDetailsSidebar-module__m-b-6___Xfp_T {
  margin-bottom: 6px !important;
}

.PatientDetailsSidebar-module__m-b-8___I40iv {
  margin-bottom: 8px !important;
}

.PatientDetailsSidebar-module__m-b-10___ObwtB {
  margin-bottom: 10px !important;
}

.PatientDetailsSidebar-module__m-b-14___Jei0W {
  margin-bottom: 14px !important;
}

.PatientDetailsSidebar-module__m-b-16___Llw2U {
  margin-bottom: 16px !important;
}

.PatientDetailsSidebar-module__m-b-20___fO4sY {
  margin-bottom: 20px !important;
}

.PatientDetailsSidebar-module__m-b-22___dRar6 {
  margin-bottom: 22px !important;
}

.PatientDetailsSidebar-module__m-b-24___G54Ie {
  margin-bottom: 24px !important;
}

.PatientDetailsSidebar-module__m-b-30___xyi7w {
  margin-bottom: 30px !important;
}

.PatientDetailsSidebar-module__m-b-32___M0rrG {
  margin-bottom: 32px !important;
}

.PatientDetailsSidebar-module__m-b-40___C03QT {
  margin-bottom: 40px !important;
}

.PatientDetailsSidebar-module__m-t-2___KjLsv {
  margin-top: 2px !important;
}

.PatientDetailsSidebar-module__m-t-3___Km5MM {
  margin-top: 3px !important;
}

.PatientDetailsSidebar-module__m-t-4___oogip {
  margin-top: 4px !important;
}

.PatientDetailsSidebar-module__m-t-5___j7fuK {
  margin-top: 5px !important;
}

.PatientDetailsSidebar-module__m-t-8___bd9rZ {
  margin-top: 8px !important;
}

.PatientDetailsSidebar-module__m-t-10___LVc3x {
  margin-top: 10px !important;
}

.PatientDetailsSidebar-module__m-t-15___CaJTE {
  margin-top: 15px !important;
}

.PatientDetailsSidebar-module__m-t-16___iCZiF {
  margin-top: 16px !important;
}

.PatientDetailsSidebar-module__m-t-20___VXOhP {
  margin-top: 20px !important;
}

.PatientDetailsSidebar-module__m-t-22___zTqXn {
  margin-top: 22px !important;
}

.PatientDetailsSidebar-module__m-t-30___I6ri5 {
  margin-top: 30px !important;
}

.PatientDetailsSidebar-module__m-t-32___LeI0i {
  margin-top: 32px !important;
}

.PatientDetailsSidebar-module__m-l-auto___DSI7D {
  margin-left: auto !important;
}

.PatientDetailsSidebar-module__m-l-4___FiHea {
  margin-left: 4px !important;
}

.PatientDetailsSidebar-module__m-l-5___F80GR {
  margin-left: 5px !important;
}

.PatientDetailsSidebar-module__m-l-6____R_wK {
  margin-left: 6px !important;
}

.PatientDetailsSidebar-module__m-l-8___gVQhm {
  margin-left: 8px !important;
}

.PatientDetailsSidebar-module__m-l-10___qJuhR {
  margin-left: 10px !important;
}

.PatientDetailsSidebar-module__m-l-16___esiMj {
  margin-left: 16px !important;
}

.PatientDetailsSidebar-module__m-l-20___VtZ4R {
  margin-left: 20px !important;
}

.PatientDetailsSidebar-module__m-l-24___ueng5 {
  margin-left: 24px !important;
}

.PatientDetailsSidebar-module__m-l-30___Iu7QN {
  margin-left: 30px !important;
}

.PatientDetailsSidebar-module__m-l-35___hYk2O {
  margin-left: 35px !important;
}

.PatientDetailsSidebar-module__m-l-40___tYklJ {
  margin-left: 40px !important;
}

.PatientDetailsSidebar-module__m-r-8___Ke_CF {
  margin-right: 8px !important;
}

.PatientDetailsSidebar-module__m-r-10___kbAYn {
  margin-right: 10px !important;
}

.PatientDetailsSidebar-module__m-r-16____gDil {
  margin-right: 16px !important;
}

.PatientDetailsSidebar-module__m-r-20___CG6no {
  margin-right: 20px !important;
}

.PatientDetailsSidebar-module__m-r-24___ckioz {
  margin-right: 24px !important;
}

.PatientDetailsSidebar-module__m-r-30___LrwEK {
  margin-right: 30px !important;
}

.PatientDetailsSidebar-module__m-r-40___hdvPF {
  margin-right: 40px !important;
}

.PatientDetailsSidebar-module__border-r-3___coALF {
  border-radius: 3px !important;
}

.PatientDetailsSidebar-module__border-r-4___CIel9 {
  border-radius: 4px !important;
}

.PatientDetailsSidebar-module__border-r-6___cFmZG {
  border-radius: 6px !important;
}

.PatientDetailsSidebar-module__border-r-10___d_Ixt {
  border-radius: 10px !important;
}

.PatientDetailsSidebar-module__border-r-12___q3RBW {
  border-radius: 12px !important;
}

.PatientDetailsSidebar-module__border-r-16___dmCZW {
  border-radius: 16px !important;
}

.PatientDetailsSidebar-module__border-r-50___gsjRY {
  border-radius: 50% !important;
}

.PatientDetailsSidebar-module__primary-border___YfsZe {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsSidebar-module__primary-border-b___fBnes {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsSidebar-module__primary-border-t___ltn5X {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsSidebar-module__primary-border-l___txoFP {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsSidebar-module__primary-border-r___er0fr {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientDetailsSidebar-module__secondary-border___nQLzZ {
  border: 1px solid #637768;
}

.PatientDetailsSidebar-module__secondary-border-b___dGN5p {
  border-bottom: 1px solid #637768;
}

.PatientDetailsSidebar-module__secondary-border-t___Z1Qsi {
  border-top: 1px solid #637768;
}

.PatientDetailsSidebar-module__secondary-border-l___db4Xp {
  border-left: 1px solid #637768;
}

.PatientDetailsSidebar-module__secondary-border-r___Srgqe {
  border-right: 1px solid #637768;
}

.PatientDetailsSidebar-module__gap-0___hnUXH {
  gap: 0 !important;
}

.PatientDetailsSidebar-module__gap-2___ExqTG {
  gap: 2px !important;
}

.PatientDetailsSidebar-module__gap-4___Awh7W {
  gap: 4px !important;
}

.PatientDetailsSidebar-module__gap-5___j2nwd {
  gap: 5px !important;
}

.PatientDetailsSidebar-module__gap-6___mqzmL {
  gap: 6px !important;
}

.PatientDetailsSidebar-module__gap-8___ZvgPd {
  gap: 8px !important;
}

.PatientDetailsSidebar-module__gap-10___OLFn7 {
  gap: 10px !important;
}

.PatientDetailsSidebar-module__gap-12___Gf6Oh {
  gap: 12px !important;
}

.PatientDetailsSidebar-module__gap-14___LTFNF {
  gap: 14px !important;
}

.PatientDetailsSidebar-module__gap-16___m2oMI {
  gap: 16px !important;
}

.PatientDetailsSidebar-module__gap-18____Tvwx {
  gap: 18px !important;
}

.PatientDetailsSidebar-module__gap-20___l0zA9 {
  gap: 20px !important;
}

.PatientDetailsSidebar-module__gap-24___s7Csr {
  gap: 24px !important;
}

.PatientDetailsSidebar-module__gap-26___qVA40 {
  gap: 26px !important;
}

.PatientDetailsSidebar-module__gap-30___FJkyX {
  gap: 30px !important;
}

.PatientDetailsSidebar-module__gap-32___yWT3p {
  gap: 32px !important;
}

.PatientDetailsSidebar-module__gap-40___WSgZR {
  gap: 40px !important;
}

.PatientDetailsSidebar-module__gap-50___cUOUa {
  gap: 50px !important;
}

.PatientDetailsSidebar-module__flex-1___JjdTf {
  flex: 1;
}

.PatientDetailsSidebar-module__flex-none___JAGwr {
  flex: none !important;
}

.PatientDetailsSidebar-module__flex-column___yetbK {
  display: flex;
  flex-direction: column !important;
}

.PatientDetailsSidebar-module__flex-row___pyIxx {
  display: flex;
  flex-direction: row !important;
}

.PatientDetailsSidebar-module__vertically-centered___GyzFJ {
  display: flex;
  align-items: center !important;
}

.PatientDetailsSidebar-module__horizontally-centered___NLgcv {
  display: flex;
  justify-content: center !important;
}

.PatientDetailsSidebar-module__horizontally-end___geQgX {
  display: flex;
  justify-content: end !important;
}

.PatientDetailsSidebar-module__vertically-start___QzFET {
  display: flex;
  align-items: start !important;
}

.PatientDetailsSidebar-module__space-between___re2Le {
  display: flex;
  justify-content: space-between !important;
}

.PatientDetailsSidebar-module__flex-wrap___xP0r9 {
  flex-wrap: wrap !important;
}

.PatientDetailsSidebar-module__height-100___A0Gpv {
  height: 100%;
}

.PatientDetailsSidebar-module__width-50___n4ipU {
  width: 50% !important;
}

.PatientDetailsSidebar-module__width-100___WpYZ8 {
  width: 100%;
}

.PatientDetailsSidebar-module__cursor-pointer___QrvnG {
  cursor: pointer;
}

.PatientDetailsSidebar-module__cursor-not-allowed___AaFaE {
  cursor: not-allowed !important;
}

.PatientDetailsSidebar-module__absolute-centered___VPdcp {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientDetailsSidebar-module__absolute___GKlYO {
  position: absolute;
}

.PatientDetailsSidebar-module__relative___KuVRG {
  position: relative;
}

.PatientDetailsSidebar-module__fixed___LSjZB {
  position: fixed;
}

.PatientDetailsSidebar-module__visible___NAiUt {
  opacity: 1;
}

.PatientDetailsSidebar-module__invisible___F9XZn {
  opacity: 0;
}

.PatientDetailsSidebar-module__col-90___mKHEF {
  width: 90% !important;
}

.PatientDetailsSidebar-module__col-auto___nyaBb {
  width: auto !important;
}

.PatientDetailsSidebar-module__medical-tabs___Ad_Km {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientDetailsSidebar-module__medical-table-new___yTF91 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91::-webkit-scrollbar-track {
  display: none;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91.PatientDetailsSidebar-module__no-pagination___KU0bL {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91.PatientDetailsSidebar-module__no-pagination___KU0bL:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91.PatientDetailsSidebar-module__no-pagination___KU0bL::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetailsSidebar-module__medical-table-new___yTF91.PatientDetailsSidebar-module__no-pagination___KU0bL::-webkit-scrollbar-track {
  display: none;
}

.PatientDetailsSidebar-module__medical-table-empty___tel5Y {
  padding: 14px 40px !important;
}

.PatientDetailsSidebar-module__icon-btn___vw_zS {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientDetailsSidebar-module__search-icon___UbPKH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientDetailsSidebar-module__disable-select___D8mAR {
  user-select: none;
}

.PatientDetailsSidebar-module__break-word___RS1De {
  word-break: break-word;
}

.PatientDetailsSidebar-module__popup-clear-btn___va4jO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientDetailsSidebar-module__scroll-m-b-20___I7KRF {
  scroll-margin-bottom: 20px;
}

.PatientDetailsSidebar-module__aside___D3E4F {
  background: #fbf7f2;
  transition-property: width, min-width;
  transition-timing-function: ease-out;
  transition-duration: 0.4s;
  display: flex;
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) - 6px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientDetailsSidebar-module__aside___D3E4F:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientDetailsSidebar-module__aside___D3E4F::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientDetailsSidebar-module__aside___D3E4F::-webkit-scrollbar-track {
  display: none;
}
.PatientDetailsSidebar-module__aside___D3E4F.PatientDetailsSidebar-module__extended___xd1f2::-webkit-scrollbar {
  background-color: #fdfbf8;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__navigation___rtKoo {
  width: 100%;
  flex: 1;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__navigation___rtKoo .PatientDetailsSidebar-module__wrapper___ZdepA {
  position: relative;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__navigation___rtKoo .PatientDetailsSidebar-module__wrapper___ZdepA .PatientDetailsSidebar-module__line___lAu_x {
  background-color: #f1bf72;
  border-radius: 0 6px 6px 0;
  position: absolute;
  width: 4px;
  bottom: 0;
  left: 0;
  top: 0;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__navigation___rtKoo .PatientDetailsSidebar-module__wrapper___ZdepA .PatientDetailsSidebar-module__dot___HxYMy {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 8px;
  display: inline-block;
  background-color: #f06c67;
  margin: 7px 12px 0 0;
  right: -3px;
  bottom: 0;
  top: 0;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__extendedSection___Apago {
  top: 0;
  flex: 1;
  position: sticky;
  background-color: #fdfbf8;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__extendedSection___Apago .PatientDetailsSidebar-module__header___Dd0z1 {
  height: 70px;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__extendedSection___Apago .PatientDetailsSidebar-module__header___Dd0z1 .PatientDetailsSidebar-module__title___Oa69b {
  color: #375844;
  line-height: 19px;
  flex: 1;
}
.PatientDetailsSidebar-module__aside___D3E4F .PatientDetailsSidebar-module__extendedSection___Apago .PatientDetailsSidebar-module__header___Dd0z1 .PatientDetailsSidebar-module__collapseButton___NDEwR {
  border-radius: 6px;
  width: auto;
  padding: 0;
}

.PatientDetailsSidebar-module__navButton___dxQjW {
  padding: 0;
  min-width: 20px !important;
  gap: 2px !important;
  margin: 0 auto;
}
.PatientDetailsSidebar-module__navButton___dxQjW > img {
  width: 22px;
  height: 22px;
}
.PatientDetailsSidebar-module__navButton___dxQjW > span {
  font-size: 10px !important;
  text-wrap: wrap !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetailsSidebar/PatientDetailsSidebar.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mBAAA;EACA,qCAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;ECGA,iHDDE;ECEF,kBAAA;EACA,kBAAA;AD4pBF;AC1pBE;EACE,oCAAA;EACA,mBAAA;AD4pBJ;ACzpBE;EACE,UAAA;EACA,6BAAA;AD2pBJ;ACxpBE;EACE,aAAA;AD0pBJ;AAjqBI;EACE,yBAAA;AAmqBN;AA/pBE;EACE,WAAA;EACA,OAAA;AAiqBJ;AA/pBI;EACE,kBAAA;AAiqBN;AA/pBM;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;AAiqBR;AA9pBM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;AAgqBR;AA3pBE;EACE,MAAA;EACA,OAAA;EACA,gBAAA;EACA,yBAAA;AA6pBJ;AA3pBI;EACE,YAAA;AA6pBN;AA3pBM;EACE,cAAA;EACA,iBAAA;EACA,OAAA;AA6pBR;AA1pBM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA4pBR;;AAtpBA;EACE,UAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;AAypBF;AAvpBE;EACE,WAAA;EACA,YAAA;AAypBJ;AAtpBE;EACE,0BAAA;EACA,0BAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.aside {\n  background: get-color(orangeNew, light);\n  transition-property: width, min-width;\n  transition-timing-function: ease-out;\n  transition-duration: 0.4s;\n  display: flex;\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(\n          --patient-details-footer\n        ) -\n        6px\n    )\n  );\n\n  &.extended {\n    &::-webkit-scrollbar {\n      background-color: get-color(grayNew, lighter);\n    }\n  }\n\n  .navigation {\n    width: 100%;\n    flex: 1;\n\n    .wrapper {\n      position: relative;\n\n      .line {\n        background-color: get-color(orangeNew);\n        border-radius: 0 6px 6px 0;\n        position: absolute;\n        width: 4px;\n        bottom: 0;\n        left: 0;\n        top: 0;\n      }\n\n      .dot {\n        position: absolute;\n        width: 8px;\n        height: 8px;\n        border-radius: 8px;\n        display: inline-block;\n        background-color: get-color(redNew, medium-dark);\n        margin: 7px 12px 0 0;\n        right: -3px;\n        bottom: 0;\n        top: 0;\n      }\n    }\n  }\n\n  .extendedSection {\n    top: 0;\n    flex: 1;\n    position: sticky;\n    background-color: get-color(grayNew, lighter);\n\n    .header {\n      height: 70px;\n\n      .title {\n        color: get-color(greenNew, dark);\n        line-height: 19px;\n        flex: 1;\n      }\n\n      .collapseButton {\n        border-radius: 6px;\n        width: auto;\n        padding: 0;\n      }\n    }\n  }\n}\n\n.navButton {\n  padding: 0;\n  min-width: 20px !important;\n  gap: 2px !important;\n  margin: 0 auto;\n\n  & > img {\n    width: 22px;\n    height: 22px;\n  }\n\n  & > span {\n    font-size: 10px !important;\n    text-wrap: wrap !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientDetailsSidebar-module__font-s-10___J9TMm`,
	"fontS12": `PatientDetailsSidebar-module__font-s-12___aqBMY`,
	"fontS13": `PatientDetailsSidebar-module__font-s-13___gvY_U`,
	"fontS14": `PatientDetailsSidebar-module__font-s-14___FQEZL`,
	"fontS15": `PatientDetailsSidebar-module__font-s-15___DzaCR`,
	"fontS16": `PatientDetailsSidebar-module__font-s-16___J_K69`,
	"fontS18": `PatientDetailsSidebar-module__font-s-18____wfIi`,
	"fontS20": `PatientDetailsSidebar-module__font-s-20___dUIdh`,
	"fontS22": `PatientDetailsSidebar-module__font-s-22___OB_tT`,
	"fontS28": `PatientDetailsSidebar-module__font-s-28___dETqg`,
	"fontW400": `PatientDetailsSidebar-module__font-w-400___qBq7u`,
	"fontW500": `PatientDetailsSidebar-module__font-w-500___kEkMh`,
	"fontW600": `PatientDetailsSidebar-module__font-w-600___v6Nkw`,
	"fontW700": `PatientDetailsSidebar-module__font-w-700___lzPcv`,
	"p5": `PatientDetailsSidebar-module__p-5___I8aY7`,
	"p12": `PatientDetailsSidebar-module__p-12___nbQuH`,
	"p16": `PatientDetailsSidebar-module__p-16___UpZwv`,
	"p30": `PatientDetailsSidebar-module__p-30___tqdmA`,
	"pB0": `PatientDetailsSidebar-module__p-b-0___PoUnm`,
	"pB5": `PatientDetailsSidebar-module__p-b-5___VVB9h`,
	"pB10": `PatientDetailsSidebar-module__p-b-10___OLk9n`,
	"pB12": `PatientDetailsSidebar-module__p-b-12___IQiU7`,
	"pB16": `PatientDetailsSidebar-module__p-b-16___MJ3jA`,
	"pB18": `PatientDetailsSidebar-module__p-b-18___EzEDF`,
	"pB20": `PatientDetailsSidebar-module__p-b-20___XSjhg`,
	"pB25": `PatientDetailsSidebar-module__p-b-25___vyBWJ`,
	"pB30": `PatientDetailsSidebar-module__p-b-30___GiQ4W`,
	"pB50": `PatientDetailsSidebar-module__p-b-50___d3PnA`,
	"pT0": `PatientDetailsSidebar-module__p-t-0___YtkS5`,
	"pT12": `PatientDetailsSidebar-module__p-t-12___BVdcO`,
	"pT16": `PatientDetailsSidebar-module__p-t-16___bc7Qg`,
	"pT18": `PatientDetailsSidebar-module__p-t-18___ZzDqN`,
	"pT20": `PatientDetailsSidebar-module__p-t-20___AOzOI`,
	"pT30": `PatientDetailsSidebar-module__p-t-30___ngpue`,
	"pT40": `PatientDetailsSidebar-module__p-t-40___TYULE`,
	"pT50": `PatientDetailsSidebar-module__p-t-50___vkwQv`,
	"pL20": `PatientDetailsSidebar-module__p-l-20___pINhv`,
	"pL30": `PatientDetailsSidebar-module__p-l-30___B85Y5`,
	"pL40": `PatientDetailsSidebar-module__p-l-40___HeuX4`,
	"pR16": `PatientDetailsSidebar-module__p-r-16___CITaT`,
	"pR20": `PatientDetailsSidebar-module__p-r-20___rkdrs`,
	"pR30": `PatientDetailsSidebar-module__p-r-30___BQzSH`,
	"pR50": `PatientDetailsSidebar-module__p-r-50___ulefd`,
	"pR60": `PatientDetailsSidebar-module__p-r-60___Hom73`,
	"mB1": `PatientDetailsSidebar-module__m-b-1___L7dNq`,
	"mB2": `PatientDetailsSidebar-module__m-b-2___ramJT`,
	"mB6": `PatientDetailsSidebar-module__m-b-6___Xfp_T`,
	"mB8": `PatientDetailsSidebar-module__m-b-8___I40iv`,
	"mB10": `PatientDetailsSidebar-module__m-b-10___ObwtB`,
	"mB14": `PatientDetailsSidebar-module__m-b-14___Jei0W`,
	"mB16": `PatientDetailsSidebar-module__m-b-16___Llw2U`,
	"mB20": `PatientDetailsSidebar-module__m-b-20___fO4sY`,
	"mB22": `PatientDetailsSidebar-module__m-b-22___dRar6`,
	"mB24": `PatientDetailsSidebar-module__m-b-24___G54Ie`,
	"mB30": `PatientDetailsSidebar-module__m-b-30___xyi7w`,
	"mB32": `PatientDetailsSidebar-module__m-b-32___M0rrG`,
	"mB40": `PatientDetailsSidebar-module__m-b-40___C03QT`,
	"mT2": `PatientDetailsSidebar-module__m-t-2___KjLsv`,
	"mT3": `PatientDetailsSidebar-module__m-t-3___Km5MM`,
	"mT4": `PatientDetailsSidebar-module__m-t-4___oogip`,
	"mT5": `PatientDetailsSidebar-module__m-t-5___j7fuK`,
	"mT8": `PatientDetailsSidebar-module__m-t-8___bd9rZ`,
	"mT10": `PatientDetailsSidebar-module__m-t-10___LVc3x`,
	"mT15": `PatientDetailsSidebar-module__m-t-15___CaJTE`,
	"mT16": `PatientDetailsSidebar-module__m-t-16___iCZiF`,
	"mT20": `PatientDetailsSidebar-module__m-t-20___VXOhP`,
	"mT22": `PatientDetailsSidebar-module__m-t-22___zTqXn`,
	"mT30": `PatientDetailsSidebar-module__m-t-30___I6ri5`,
	"mT32": `PatientDetailsSidebar-module__m-t-32___LeI0i`,
	"mLAuto": `PatientDetailsSidebar-module__m-l-auto___DSI7D`,
	"mL4": `PatientDetailsSidebar-module__m-l-4___FiHea`,
	"mL5": `PatientDetailsSidebar-module__m-l-5___F80GR`,
	"mL6": `PatientDetailsSidebar-module__m-l-6____R_wK`,
	"mL8": `PatientDetailsSidebar-module__m-l-8___gVQhm`,
	"mL10": `PatientDetailsSidebar-module__m-l-10___qJuhR`,
	"mL16": `PatientDetailsSidebar-module__m-l-16___esiMj`,
	"mL20": `PatientDetailsSidebar-module__m-l-20___VtZ4R`,
	"mL24": `PatientDetailsSidebar-module__m-l-24___ueng5`,
	"mL30": `PatientDetailsSidebar-module__m-l-30___Iu7QN`,
	"mL35": `PatientDetailsSidebar-module__m-l-35___hYk2O`,
	"mL40": `PatientDetailsSidebar-module__m-l-40___tYklJ`,
	"mR8": `PatientDetailsSidebar-module__m-r-8___Ke_CF`,
	"mR10": `PatientDetailsSidebar-module__m-r-10___kbAYn`,
	"mR16": `PatientDetailsSidebar-module__m-r-16____gDil`,
	"mR20": `PatientDetailsSidebar-module__m-r-20___CG6no`,
	"mR24": `PatientDetailsSidebar-module__m-r-24___ckioz`,
	"mR30": `PatientDetailsSidebar-module__m-r-30___LrwEK`,
	"mR40": `PatientDetailsSidebar-module__m-r-40___hdvPF`,
	"borderR3": `PatientDetailsSidebar-module__border-r-3___coALF`,
	"borderR4": `PatientDetailsSidebar-module__border-r-4___CIel9`,
	"borderR6": `PatientDetailsSidebar-module__border-r-6___cFmZG`,
	"borderR10": `PatientDetailsSidebar-module__border-r-10___d_Ixt`,
	"borderR12": `PatientDetailsSidebar-module__border-r-12___q3RBW`,
	"borderR16": `PatientDetailsSidebar-module__border-r-16___dmCZW`,
	"borderR50": `PatientDetailsSidebar-module__border-r-50___gsjRY`,
	"primaryBorder": `PatientDetailsSidebar-module__primary-border___YfsZe`,
	"primaryBorderB": `PatientDetailsSidebar-module__primary-border-b___fBnes`,
	"primaryBorderT": `PatientDetailsSidebar-module__primary-border-t___ltn5X`,
	"primaryBorderL": `PatientDetailsSidebar-module__primary-border-l___txoFP`,
	"primaryBorderR": `PatientDetailsSidebar-module__primary-border-r___er0fr`,
	"secondaryBorder": `PatientDetailsSidebar-module__secondary-border___nQLzZ`,
	"secondaryBorderB": `PatientDetailsSidebar-module__secondary-border-b___dGN5p`,
	"secondaryBorderT": `PatientDetailsSidebar-module__secondary-border-t___Z1Qsi`,
	"secondaryBorderL": `PatientDetailsSidebar-module__secondary-border-l___db4Xp`,
	"secondaryBorderR": `PatientDetailsSidebar-module__secondary-border-r___Srgqe`,
	"gap0": `PatientDetailsSidebar-module__gap-0___hnUXH`,
	"gap2": `PatientDetailsSidebar-module__gap-2___ExqTG`,
	"gap4": `PatientDetailsSidebar-module__gap-4___Awh7W`,
	"gap5": `PatientDetailsSidebar-module__gap-5___j2nwd`,
	"gap6": `PatientDetailsSidebar-module__gap-6___mqzmL`,
	"gap8": `PatientDetailsSidebar-module__gap-8___ZvgPd`,
	"gap10": `PatientDetailsSidebar-module__gap-10___OLFn7`,
	"gap12": `PatientDetailsSidebar-module__gap-12___Gf6Oh`,
	"gap14": `PatientDetailsSidebar-module__gap-14___LTFNF`,
	"gap16": `PatientDetailsSidebar-module__gap-16___m2oMI`,
	"gap18": `PatientDetailsSidebar-module__gap-18____Tvwx`,
	"gap20": `PatientDetailsSidebar-module__gap-20___l0zA9`,
	"gap24": `PatientDetailsSidebar-module__gap-24___s7Csr`,
	"gap26": `PatientDetailsSidebar-module__gap-26___qVA40`,
	"gap30": `PatientDetailsSidebar-module__gap-30___FJkyX`,
	"gap32": `PatientDetailsSidebar-module__gap-32___yWT3p`,
	"gap40": `PatientDetailsSidebar-module__gap-40___WSgZR`,
	"gap50": `PatientDetailsSidebar-module__gap-50___cUOUa`,
	"flex1": `PatientDetailsSidebar-module__flex-1___JjdTf`,
	"flexNone": `PatientDetailsSidebar-module__flex-none___JAGwr`,
	"flexColumn": `PatientDetailsSidebar-module__flex-column___yetbK`,
	"flexRow": `PatientDetailsSidebar-module__flex-row___pyIxx`,
	"verticallyCentered": `PatientDetailsSidebar-module__vertically-centered___GyzFJ`,
	"horizontallyCentered": `PatientDetailsSidebar-module__horizontally-centered___NLgcv`,
	"horizontallyEnd": `PatientDetailsSidebar-module__horizontally-end___geQgX`,
	"verticallyStart": `PatientDetailsSidebar-module__vertically-start___QzFET`,
	"spaceBetween": `PatientDetailsSidebar-module__space-between___re2Le`,
	"flexWrap": `PatientDetailsSidebar-module__flex-wrap___xP0r9`,
	"height100": `PatientDetailsSidebar-module__height-100___A0Gpv`,
	"width50": `PatientDetailsSidebar-module__width-50___n4ipU`,
	"width100": `PatientDetailsSidebar-module__width-100___WpYZ8`,
	"cursorPointer": `PatientDetailsSidebar-module__cursor-pointer___QrvnG`,
	"cursorNotAllowed": `PatientDetailsSidebar-module__cursor-not-allowed___AaFaE`,
	"absoluteCentered": `PatientDetailsSidebar-module__absolute-centered___VPdcp`,
	"absolute": `PatientDetailsSidebar-module__absolute___GKlYO`,
	"relative": `PatientDetailsSidebar-module__relative___KuVRG`,
	"fixed": `PatientDetailsSidebar-module__fixed___LSjZB`,
	"visible": `PatientDetailsSidebar-module__visible___NAiUt`,
	"invisible": `PatientDetailsSidebar-module__invisible___F9XZn`,
	"col90": `PatientDetailsSidebar-module__col-90___mKHEF`,
	"colAuto": `PatientDetailsSidebar-module__col-auto___nyaBb`,
	"medicalTabs": `PatientDetailsSidebar-module__medical-tabs___Ad_Km`,
	"medicalTableNew": `PatientDetailsSidebar-module__medical-table-new___yTF91`,
	"noPagination": `PatientDetailsSidebar-module__no-pagination___KU0bL`,
	"medicalTableEmpty": `PatientDetailsSidebar-module__medical-table-empty___tel5Y`,
	"iconBtn": `PatientDetailsSidebar-module__icon-btn___vw_zS`,
	"searchIcon": `PatientDetailsSidebar-module__search-icon___UbPKH`,
	"disableSelect": `PatientDetailsSidebar-module__disable-select___D8mAR`,
	"breakWord": `PatientDetailsSidebar-module__break-word___RS1De`,
	"popupClearBtn": `PatientDetailsSidebar-module__popup-clear-btn___va4jO`,
	"scrollMB20": `PatientDetailsSidebar-module__scroll-m-b-20___I7KRF`,
	"aside": `PatientDetailsSidebar-module__aside___D3E4F`,
	"extended": `PatientDetailsSidebar-module__extended___xd1f2`,
	"navigation": `PatientDetailsSidebar-module__navigation___rtKoo`,
	"wrapper": `PatientDetailsSidebar-module__wrapper___ZdepA`,
	"line": `PatientDetailsSidebar-module__line___lAu_x`,
	"dot": `PatientDetailsSidebar-module__dot___HxYMy`,
	"extendedSection": `PatientDetailsSidebar-module__extendedSection___Apago`,
	"header": `PatientDetailsSidebar-module__header___Dd0z1`,
	"title": `PatientDetailsSidebar-module__title___Oa69b`,
	"collapseButton": `PatientDetailsSidebar-module__collapseButton___NDEwR`,
	"navButton": `PatientDetailsSidebar-module__navButton___dxQjW`
};
module.exports = ___CSS_LOADER_EXPORT___;
